import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_50 } from '@/lib/gridElements/size';
import { X } from '@/lib/socialProfile';

import { BarGroupedChart } from '@/components/composite/Charts/BarGroupedChart';

export const postsHistoryConfig: ChartType<typeof BarGroupedChart> = {
    title: 'chart.twitter.posts_history',
    tooltip: 'chart.twitter.posts_history_tooltip',
    id: 'posts_history',
    margin: { left: -30, bottom: 25, right: 10 },
    name: {
        date: 'date',
        value: 'chart.twitter.posts_history_name'
    },
    social: X,
    color: {
        value: 'blue'
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    isXAxisDate: true,
    element: BarGroupedChart
};
